import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import '../styles/chapter.css';
import { chapters } from '../pages/HowTo/Chapters';

const ChapterTemplate = () => {
  const { chapterId } = useParams();
  const location = useLocation();
  const chapter = chapters.find(c => c.id === chapterId);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setProgress(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!chapter) {
    return <p>Chapter not found</p>;
  }

  return (
    <div className="chapter-wrapper">
      <aside className="chapter-sidebar">
        <ul>
        <div className="sidebar-header">
            How to Train Chess
        </div>
          {chapters.map(c => (
            <li key={c.id}>
              <Link
                to={`/howtotrainchess/${c.id}`}
                className={location.pathname === `/howtotrainchess/${c.id}` ? 'active-link' : ''}
              >
                {c.title}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <section className="chapter-content">
        <div className="chapter-progress-bar" style={{ width: `${progress}%` }} />
        <div className="chapter-title">{chapter.title}</div>
        <div className="chapter-subtitle">{chapter.subtitle}</div>
        {chapter.image && (
          <img src={chapter.image} alt={chapter.title} className="chapter-image" />
        )}
        <div className="chapter-body">
          <p>{chapter.content}</p>
        </div>
      </section>
    </div>
  );
};

export default ChapterTemplate;
